import React from 'react';
import small_logo from '../assets/small_logo.svg';



export default function MediaCard({media}) {
    const contentText  = media?.content?.trim() || '';
  
    const title = media?.title || '';
    const hostName = media?.host_name || '';
    const hostTitle = media?.host_title || '';
    const avatar = media?.avatar;
    const metaLabel = media?.meta_label || '';
    const metaValue = media?.meta_value || '';
    const mediaUrl = media?.media_url || '#';

    // Avatar initial fallback
    const avatarInitial =
      (hostName?.trim?.()[0]) ||
       '•';
  
  return (
 <div className="media-card__container ">
        <div className="media-card__wrapper">
          <div className="media-card__image-wrapper">

                {/* Top-left watermark */}
            <div className="media-card__logo">
              <img src={small_logo} alt="" className="media-card__logo-img" />
            </div>


            {/* Center play button */}
            <a className="media-card__play-button media-play-button"  href={mediaUrl}  aria-label="Play" target="_blank" rel="noopener noreferrer">
               <span className="media-card__play-btn">
                   <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8345 7.32765C17.5939 8.35943 17.5939 10.9389 15.8345 11.9707L3.95862 18.9352C2.19923 19.967 -8.88027e-08 18.6772 0 16.6137L5.99418e-07 2.68464C6.88221e-07 0.62108 2.19924 -0.668642 3.95863 0.363138L15.8345 7.32765Z" fill="white"/>
                  </svg>
                </span>
            </a>

            {/* Quote panel */}
            <div className="media-card__quote-panel media-quote-panel">
              <div className="media-card__quote-content">
                {contentText && (
                  <p className="media-card__quote-text"  dangerouslySetInnerHTML={{ __html: contentText }} />
                  )  }

                <div className="media-card__quote-meta">
                  {hostTitle && hostName && (
                     <div className="media-card__quote-host">
                      <div className="media-card__quote-host-label">
                        <span>{hostTitle}</span>
                      </div>
                     <div className="media-card__quote-host-name">
                        <span className="media-card__avatar">
                          {avatar ? (
                            <img src={avatar} alt={hostTitle} className="media-card__avatar-img" />
                          ) : (
                            <span>{avatarInitial}</span>
                          )}
                        </span>
                       <span>{hostName }</span>
                     </div>
                    
                   </div>
                  )}
                  {metaLabel && metaValue && (
                     <div className="media-card__quote-host">
                     <div className="media-card__quote-host-label">
                       <span>{metaLabel}</span>
                     </div>
                     <div className="media-card__quote-host-name">
                       <span>{metaValue }</span>
                     </div>
                   </div>
                  )}
                
                </div>
                             
              </div>
            </div>


            {/* Poster image + gradient overlay */}
            <div className="media-card__image-overlay">
              {media?.image && (
                <img
                  src={media.image}
                  alt={title || 'media'}
                  className="media-card__poster-img"
                  loading="lazy"
                />
              )}
              <div className="media-card__gradient" />
            </div>
        
          </div>      
        </div>
      </div>
   
  );
};

 
 